<template>
  <PurchaseHeader>
    <PurchaseTable/>
  </PurchaseHeader>
</template>

<script>
import PurchaseHeader from "@/purchase/components/PurchaseHeader.vue";
import PurchaseTable from "@/purchase/components/tables/PurchaseTable.vue";

export default {
  name: 'PurchaseView',
  components: {PurchaseHeader, PurchaseTable}
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY

  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
